// Espace Propriétaire — page Employés.
// Réutilise la même page que l'espace Agence : les liens et les libellés
// s'adaptent automatiquement selon l'URL courante.
import AgenceEmployesPage from "@/pages/agence/employes/page";

export default function ProprietaireEmployesPage() {
  return <AgenceEmployesPage />;
}